import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnEditUserMiniAppActions(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos atualizar as actions.'
            break
        case '2xx':
            message = 'Atualizamos as actions.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não atualizamos as actions do usuário. Por favor, tente novamente mais tarde.'
    }

    return message
}
